var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger",on:{"click":_vm.handleClick}},[_c('input',{ref:"checkbox",staticClass:"checkbox",attrs:{"type":"checkbox"}}),_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }